import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';

function ProgressIcon(props) {
  const { data } = props;

  const { limit = 0, currentValue = 0 } = data || {};

  const progress = currentValue / limit;

  // We're removing PI/2 from the circle, 25%, so instead of using percentages, we use per 75
  const progressPercentage = progress ? progress * 100 : 0;

  const per75 = progress ? progressPercentage * 0.75 : 0;

  // Setting up progress path
  const dashToUse = `${per75}, 75`;
  const backgroundClass = 'best-day-graph-background';
  const contentPathClass = 'best-day-graph-path';

  return (
    <div className="progress-icon-container">
      <svg viewBox="0 0 36 36" className="best-day-graph">
        <path
          className={backgroundClass}
          strokeDasharray="75, 75"
          d="M6.7460 29.25395
              A 15.9155 15.9155 0 0 1 18 2.0845
              A 15.9155 15.9155 0 0 1 29.25395 29.25395"
        />
        <path
          className={contentPathClass}
          strokeDasharray={dashToUse}
          d="M6.7460 29.25395
              A 15.9155 15.9155 0 0 1 18 2.0845
              A 15.9155 15.9155 0 0 1 29.25395 29.25395"
        />
      </svg>
      <br />
      <div className="target-info-container">
        <div className="row">
          <div className="info-target col-lg-12 col-12">
            {`${progressPercentage.toFixed(0)}%`}
          </div>
        </div>
      </div>
    </div>
  );
}

ProgressIcon.propTypes = {
  data: PropTypes.shape({
    limit: PropTypes.number,
    limitAchieved: PropTypes.bool,
    currentValue: PropTypes.number,
  }).isRequired,
};
export default translate(ProgressIcon);
